/**
 * Предшественник из графика другого проекта (ПЛ-05): поиск по коду, названию работы или шифру проекта —
 * только проекты, которые человек видит.
 */
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { api } from '../../lib/api';
import { Input } from '../../ui/form';
import { fmtMoment } from './model';

export interface ExternalActivity {
  id: string;
  code: string;
  name: string;
  projectCode: string;
  start: string | null;
  finish: string | null;
}

export function ExternalPicker({
  scheduleId,
  onPick,
}: {
  scheduleId: string;
  onPick: (a: ExternalActivity) => void;
}) {
  const [q, setQ] = useState('');
  // Запрос — через полсекунды после последней буквы
  const [term, setTerm] = useState('');
  useEffect(() => {
    const t = setTimeout(() => setTerm(q.trim()), 400);
    return () => clearTimeout(t);
  }, [q]);
  const r = useQuery({
    queryKey: ['external-activities', scheduleId, term],
    queryFn: () =>
      api<ExternalActivity[]>(`/schedules/${scheduleId}/external-activities`, { query: { q: term } }),
    enabled: term.length >= 2,
    staleTime: 30_000,
  });
  return (
    <div className="mt-2 flex flex-col gap-1">
      <Input
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="Работа другого проекта: шифр, код или название"
        aria-label="Найти работу другого проекта"
        className="max-md:h-11"
      />
      {term.length >= 2 && r.data ? (
        r.data.length ? (
          <ul className="max-h-48 overflow-y-auto rounded-md border border-line">
            {r.data.map((a) => (
              <li key={a.id}>
                <button
                  type="button"
                  onClick={() => {
                    onPick(a);
                    setQ('');
                  }}
                  className="flex min-h-11 w-full flex-col items-start px-3 py-1 text-left text-[13px] hover:bg-surface-2 md:min-h-0"
                >
                  <span>
                    {a.projectCode} · {a.code} {a.name}
                  </span>
                  <span className="text-[12px] text-ink-2">
                    {fmtMoment(a.start)} — {fmtMoment(a.finish)}
                  </span>
                </button>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-[12px] text-ink-2">Не найдено в доступных вам проектах</p>
        )
      ) : null}
    </div>
  );
}
